(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1835],{

/***/ 91929:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/business-days-calculator",
      function () {
        return __webpack_require__(99064);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 99064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ business_days_calculator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/CalculatorBlogs/Blog.jsx + 1 modules
var Blog = __webpack_require__(56130);
;// CONCATENATED MODULE: ./components/Tools/NumberOfDays.jsx


const NumberOfDays = ()=>{
    const [startDate, setStartDate] = (0,react.useState)("");
    const [endDate, setEndDate] = (0,react.useState)("");
    const [countWorkdays, setCountWorkdays] = (0,react.useState)(false);
    const [result, setResult] = (0,react.useState)(null);
    function handleStartDateChange(event) {
        setStartDate(event.target.value);
    }
    function handleEndDateChange(event) {
        setEndDate(event.target.value);
    }
    function handleCountWorkdaysChange(event) {
        setCountWorkdays(event.target.checked);
    }
    function handleCalculateClick() {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const oneDay = 24 * 60 * 60 * 1000;
        let count = Math.round(Math.abs((start - end) / oneDay));
        if (countWorkdays) {
            let workdays = 0;
            for(let i = 0; i < count; i++){
                const date = new Date(start.getTime() + i * oneDay);
                if (date.getDay() !== 0 && date.getDay() !== 6) {
                    workdays++;
                }
            }
            count = workdays;
        }
        setResult(count);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] lg:w-[50%] mx-auto mt-[170px] drop-shadow-xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "font-bold text-[30px]",
                children: "Calculate number of days"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-[20px] text-purple-800",
                children: "Calculate the number of days or workdays between two dates"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-[100%] md:w-[700px] bg-gray-200 mt-[30px] p-[30px] rounded-lg drop-shadow-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-[15px] flex-col md:flex-row justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "text-[20px] font-medium",
                                        htmlFor: "start",
                                        children: "Start Date"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        alue: startDate,
                                        onChange: handleStartDateChange,
                                        className: "outline-none w-[250px] h-[50px] rounded-lg px-[20px]",
                                        type: "date",
                                        name: "start",
                                        id: ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[20px] hidden md:block h-[2px] bg-gray-800 translate-y-[30px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "text-[20px] font-medium",
                                        htmlFor: "end",
                                        children: "End Date"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        value: endDate,
                                        onChange: handleEndDateChange,
                                        className: "outline-none w-[250px] h-[50px] rounded-lg px-[20px]",
                                        type: "date",
                                        name: "end",
                                        id: ""
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "border-b-[1px] border-b-gray-400 py-[30px] font-light",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                checked: countWorkdays,
                                onChange: handleCountWorkdaysChange,
                                className: "mr-[8px]",
                                type: "checkbox",
                                id: "vehicle1",
                                name: "vehicle1",
                                value: "count"
                            }),
                            " Count only workdays"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: handleCalculateClick,
                        className: "bg-gradient-to-r from-violet-500 to-indigo-500 hover:opacity-75 text-[20px] w-[210px] mx-auto mt-[30px] rounded-full text-white h-[55px] flex justify-center items-center gap-[10px]",
                        children: "Calculate"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "py-[30px] flex flex-col gap-[10px] sm:flex-row justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex sm:flex-col gap-[10px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[20px] font-medium",
                                        children: "Total work days"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[20px] font-medium",
                                        children: result ? result : "--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sm:text-end font-light text-gray-600",
                                children: [
                                    "Start and end dates are included",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-blue-500 underline",
                                        children: "National holidays "
                                    }),
                                    " are counted as working days"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Tools_NumberOfDays = (NumberOfDays);

;// CONCATENATED MODULE: ./components/Tools/DueDate.jsx


const DueDate = ()=>{
    const [startDate2, setStartDate2] = (0,react.useState)("");
    const [numWorkingDays, setNumWorkingDays] = (0,react.useState)("");
    const [excludeWeekends, setExcludeWeekends] = (0,react.useState)(false);
    const [outputDate, setOutputDate] = (0,react.useState)("");
    const handleStartDateChange2 = (event)=>{
        setStartDate2(event.target.value);
    };
    const handleNumWorkingDaysChange = (event)=>{
        setNumWorkingDays(event.target.value);
    };
    const handleExcludeWeekendsChange = (event)=>{
        setExcludeWeekends(event.target.checked);
    };
    const calculateDate = (event)=>{
        event.preventDefault();
        let currentDate = new Date(startDate2);
        // loop through each working day and add to the date
        for(let i = 0; i < numWorkingDays; i++){
            // if excluding weekends, skip Saturday and Sunday
            if (excludeWeekends) {
                let dayOfWeek = currentDate.getDay();
                if (dayOfWeek === 6) {
                    currentDate.setDate(currentDate.getDate() + 2); // add 2 days for Sunday and Monday
                } else if (dayOfWeek === 0) {
                    currentDate.setDate(currentDate.getDate() + 1); // add 1 day for Monday
                }
            }
            // add 1 day to the date
            currentDate.setDate(currentDate.getDate() + 1);
        }
        // set the output date
        setOutputDate(currentDate.toDateString());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] lg:w-[50%] mx-auto mt-[50px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "font-bold text-[30px]",
                children: "Calculate due date"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-[20px] text-purple-800",
                children: "Figure out the day by which your project can be completed"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-[100%] md:w-[700px] bg-gray-200 mt-[30px] p-[30px] rounded-lg drop-shadow-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-[15px] flex-col md:flex-row justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "text-[20px] font-medium",
                                        htmlFor: "start",
                                        children: "Start Date"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        value: startDate2,
                                        onChange: handleStartDateChange2,
                                        className: "outline-none w-[250px] h-[50px] rounded-lg px-[20px]",
                                        type: "date",
                                        name: "start",
                                        id: ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[20px] hidden md:block h-[2px] bg-gray-800 translate-y-[30px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "text-[20px] font-medium",
                                        htmlFor: "end",
                                        children: "Working Days"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        value: numWorkingDays,
                                        onChange: handleNumWorkingDaysChange,
                                        className: "outline-none w-[250px] h-[50px] rounded-lg px-[20px]",
                                        type: "text",
                                        name: "end",
                                        id: ""
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "border-b-[1px] border-b-gray-400 py-[30px] font-light",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                checked: excludeWeekends,
                                onChange: handleExcludeWeekendsChange,
                                className: "mr-[8px]",
                                type: "checkbox",
                                id: "vehicle1",
                                name: "vehicle1",
                                value: "count"
                            }),
                            " Exclude the weekends"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: calculateDate,
                        className: "bg-gradient-to-r from-violet-500 to-indigo-500 hover:opacity-75 text-[20px] w-[210px] mx-auto mt-[30px] rounded-full text-white h-[55px] flex justify-center items-center gap-[10px]",
                        children: "Calculate"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "py-[30px] flex flex-col gap-[10px] sm:flex-row justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex sm:flex-col gap-[10px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[20px] font-medium",
                                        children: "End Date"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[20px] font-medium",
                                        children: outputDate ? outputDate : "--/--/--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sm:text-end font-light text-gray-600",
                                children: [
                                    "Start and end dates are included",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-blue-500 underline",
                                        children: "National holidays "
                                    }),
                                    " are counted as working days"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Tools_DueDate = (DueDate);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/calculators/business-days-calculator/index.jsx






const BlogData = [
    {
        id: 1,
        question: "How does the Business Days Calculator work?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "",
                    children: [
                        "The Business Days Calculator is a simple tool that helps you calculate the number of working days between two dates. It excludes weekends and public holidays, so you can easily determine the actual number of business days in a given time period.",
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "",
                    children: "With this tool, you can optimize your work scheduling and manage your projects more efficiently."
                })
            ]
        })
    },
    {
        id: 2,
        question: "Why do I need a Business Days Calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "A Business Days Calculator can help you plan and prioritize your projects, allocate resources more effectively, and meet important deadlines. By accurately calculating the number of working days between two dates, you can ensure that you have enough time to complete your tasks and deliverables. This tool is especially useful for businesses and organizations that need to manage their work scheduling and project timelines."
            })
        })
    },
    {
        id: 3,
        question: "How can I use the Business Days Calculator to plan my projects?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "With the Business Days Calculator, you can easily calculate the number of working days between project milestones, task deadlines, or other important dates. This allows you to plan your projects more effectively, allocate resources appropriately, and ensure that you meet your goals and objectives on time. By streamlining your work scheduling, you can optimize your productivity and achieve better results."
            })
        })
    },
    {
        id: 4,
        question: "Is the Business Days Calculator easy to use?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "Yes, the Business Days Calculator is designed to be user-friendly and easy to use. Simply enter the start and end dates, select the appropriate options for weekends and public holidays, and click calculate. The tool will generate the number of working days between the two dates, as well as a calendar view that highlights the excluded weekends and holidays."
            })
        })
    },
    {
        id: 5,
        question: "Can I use the Business Days Calculator for personal or non-commercial use?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "Absolutely, the Business Days Calculator is free to use for personal or non-commercial purposes. You can use it to calculate the number of working days between two dates for your personal projects or other non-commercial activities. The tool is also useful for students, freelancers, and other individuals who need to manage their time more effectively."
            })
        })
    },
    {
        id: 6,
        question: "How can the Business Days Calculator benefit my business?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "The Business Days Calculator can help your business streamline its work scheduling, allocate resources more efficiently, and meet important deadlines. By accurately calculating the number of working days between two dates, you can ensure that you have enough time to complete your projects and deliverables. This can lead to increased productivity, improved customer satisfaction, and better business results overall."
            })
        })
    }
];
const BusinessCalculator = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mx-auto pt-[60px] pb-[100px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Business Days Calculator | Calculators | BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/calculators/business-days-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/calculators/business-days-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Business Days Calculator | Calculators | BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/calculators/business-days-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 z-[-500] left-0 w-full bg-violet-500 h-[500px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center text-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-[30px] md:text-[45px] mb-[20px] font-bold w-[100%] lg:w-[80%] mx-auto",
                        children: "Business Days Calculator: Work Days Between Dates"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "w-[100%] lg:w-[80%] text-[16px] md:text-[20px] mx-auto text-center font-light",
                        children: "Streamline your work scheduling with our free Business Days Calculator tool. Calculate the number of working days between two dates while excluding weekends and public holidays. This efficient calculator helps you plan and prioritize your projects, optimize resource allocation, and meet critical deadlines. Try our Business Days Calculator now and simplify your workday management."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tools_NumberOfDays, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tools_DueDate, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog/* default */.Z, {
                heading: "Business Days Calculator FAQs",
                BlogData: BlogData
            })
        ]
    });
};
/* harmony default export */ var business_days_calculator = (BusinessCalculator);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,9774,2888,179], function() { return __webpack_exec__(91929); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);